import React from 'react';
import { AllBusinesses } from '@/components/business';

export const AllBusinessesPage: React.FC = () => {
  return <AllBusinesses />;
};
